import { EditorStarterItem } from '../items/item-type';
import { TrackType } from '../state/types';

export const isTrackPositionBusy = ({
  track,
  startAt,
  items,
  durationInFrames,
}: {
  track: TrackType;
  items: Record<string, EditorStarterItem>;
  startAt: number;
  durationInFrames: number;
}) => {
  return track.items.find((itemId) => {
    const item = items[itemId];
    if (!item) {
      // 트랙에 아이템 ID가 남아있지만 items 맵에 없는 경우 (상태 불일치)
      // 에러 대신 skip하여 에셋 추가 등 후속 작업이 실패하지 않도록 한다
      console.warn(
        `[isTrackPositionBusy] Item ${itemId} not found in items map, skipping`,
      );
      return false;
    }
    return (
      (item.from <= startAt && item.from + item.durationInFrames > startAt) ||
      (item.from > startAt && item.from < startAt + durationInFrames)
    );
  });
};
